module.exports = __webpack_public_path__ + "static/media/filter.2cdb9416.svg";